import { createContext } from "react";

import { User } from "../store/pomeriumApi";

export type UserState = {
  user?: User;
};

export const UserContext = createContext<UserState>({});

export const UserConsumer = UserContext.Consumer;
